import { DataSourceRegistryPath } from "features/data-source/data-source-registry";
import { shouldUseNewApproach } from "features/data-source/data-source.utils";
import { useHasUserArea } from "hooks/useHasUserArea";

export const useShouldUseNewApproach = (dataSourcePath: DataSourceRegistryPath) => {
    const hasDataSourcesNewApproachEnabled = useHasUserArea(["Refactor_DataSourcesNewApproach"]);
    const useNewApproach = shouldUseNewApproach(dataSourcePath, hasDataSourcesNewApproachEnabled);
    return { useNewApproach };
};
